import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./recipient-select.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./recipient-select.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, Input, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, Validators } from "@angular/forms";
import * as RecipientFormConstants from "./recipient-select.constants";
import { AppControllerService } from "../../../app-controller.service";
import { AlertType } from "../../models/alert";
import { SharedConstants } from "../../constants/shared.constants";
import { phoneNumberValidator } from "../../classes/phone-number-validator";
import { CRUDOperation } from "../../models/crud-operation-enum.model";
import { forkJoin, Subject, take } from "rxjs";
import { UserInformationService } from "../../services/user/user-information.service";
import { RecipientSelectFilterComponent } from "./recipient-select-filter/recipient-select-filter.component";
import { RecipientSelectService } from "./shared/service/recipient-select.service";
import { LookupConstants } from "../../constants/lookup.constants";
import { AutoUnsub } from "../../decorators/autounsub.decorator";
import { map, takeUntil } from "rxjs/operators";
import { SettingsService } from "src/app/core/settings/settings.service";
let RecipientSelectComponent = class RecipientSelectComponent {
    appController;
    formBuilder;
    settingsService;
    recipientSelectService;
    userInformationService;
    changeDetectorRef;
    _destroy$ = new Subject();
    recipientSelectFilter;
    showFields;
    disableFilter;
    isInternalRecipient = false;
    configurableLabel;
    disableAdd;
    recipientGroupsToFilterBy = [];
    disableEditing;
    showRecipientGroupsDropdown = true;
    isModalForm = false;
    isAddRecipientModalForm = false;
    isEditRecipientModalForm = false;
    jobID;
    showSACAPOptions = false;
    recipientForm;
    groupsHeaderPlaceHolder = RecipientFormConstants.GROUPS_HEADER_PLACEHOLDER;
    groupsTextPlaceHolder = RecipientFormConstants.GROUPS_TEXT_PLACEHOLDER;
    groups = RecipientFormConstants.GROUPS_FORM_CONTROL;
    groupsStringArrayControlName = RecipientFormConstants.GROUPS_STRING_ARRAY_FORM_CONTROL;
    professionalBodyHeaderPlaceHolder = RecipientFormConstants.PROFESSIONAL_BODY_HEADER_PLACEHOLDER;
    relativeDetailsHeaderPlaceHolder = RecipientFormConstants.RELATIVE_DETAILS_HEADER_PLACEHOLDER;
    employersDetailsHeaderPlaceHolder = RecipientFormConstants.EMPLOYERS_DETAILS_HEADER_PLACEHOLDER;
    streetAddressHeaderPlaceHolder = RecipientFormConstants.STREET_ADDRESS_HEADER_PLACEHOLDER;
    postalAddressHeaderPlaceHolder = RecipientFormConstants.POSTAL_ADDRESS_HEADER_PLACEHOLDER;
    countryOptions = LookupConstants.COUNTRIES;
    provinceOptions = LookupConstants.PROVINCE;
    maritalStatusOptions = LookupConstants.MARITAL_STATUS_LOOKUPS_RECIPIENT_COMPONENTS;
    employmentStatusOptions = LookupConstants.EMPLOYMENT_STATUS_LOOKUPS_RECIPIENT_COMPONENTS;
    genderOptions = [];
    disabilityOptions = [];
    nameTextPlaceHolder = RecipientFormConstants.NAME_TEXT_PLACEHOLDER;
    surnameTextPlaceHolder = RecipientFormConstants.SURNAME_TEXT_PLACEHOLDER;
    homePhoneTextPlaceHolder = RecipientFormConstants.HOMEPHONE_TEXT_PLACEHOLDER;
    telephoneTextPlaceHolder = RecipientFormConstants.TELEPHONE_TEXT_PLACEHOLDER;
    cellphoneTextPlaceHolder = RecipientFormConstants.CELLPHONE_TEXT_PLACEHOLDER;
    defaultCommunicationMethodPlaceHolder = "Preferred method of communication";
    defaultCommunicationMethodFormControl = "defaultCommunicationMethod";
    emailRadioButtonPlaceholder = "Email";
    smsRadioButtonPlaceholder = "SMS";
    emailTextPlaceHolder = RecipientFormConstants.EMAIL_TEXT_PLACEHOLDER;
    clientVatNoTextPlaceHolder = RecipientFormConstants.CLIENT_VAT_NO_PLACEHOLDER;
    organisationTextPlaceHolder = RecipientFormConstants.ORGANISATION_TEXT_PLACEHOLDER;
    designationTextPlaceHolder = RecipientFormConstants.DESIGNATION_TEXT_PLACEHOLDER;
    professionalBodyTextPlaceHolder = RecipientFormConstants.PROFESSIONAL_BODY_TEXT_PLACEHOLDER;
    professionalBodyRegNoTextPlaceHolder = RecipientFormConstants.PROFESSIONAL_BODY_REGNO_TEXT_PLACEHOLDER;
    maritalStatusPlaceHolder = RecipientFormConstants.MARITAL_STATUS_TEXT_PLACEHOLDER;
    relativesFullNamePlaceHolder = RecipientFormConstants.RELATIVES_FULL_NAME_TEXT_PLACEHOLDER;
    relativesContactNumberPlaceHolder = RecipientFormConstants.RELATIVES_CONTACT_NUMBER_TEXT_PLACEHOLDER;
    relativesAddressPlaceHolder = RecipientFormConstants.RELATIVES_ADDRESS_TEXT_PLACEHOLDER;
    employmentStatusPlaceHolder = RecipientFormConstants.EMPLOYMENT_STATUS_TEXT_PLACEHOLDER;
    employersNamePlaceHolder = RecipientFormConstants.EMPLOYERS_NAME_TEXT_PLACEHOLDER;
    employersContactNumberPlaceHolder = RecipientFormConstants.EMPLOYERS_CONTACT_NUMBER_TEXT_PLACEHOLDER;
    employersAddressPlaceHolder = RecipientFormConstants.EMPLOYERS_ADDRESS_TEXT_PLACEHOLDER;
    idNumberPlaceHolder = RecipientFormConstants.ID_NUMBER_TEXT_PLACEHOLDER;
    passportNumberTextPlaceHolder = RecipientFormConstants.PASSPORT_NUMBER_TEXT_PLACEHOLDER;
    genderTextPlaceHolder = RecipientFormConstants.GENDER_TEXT_PLACEHOLDER;
    disabilityTextPlaceHolder = RecipientFormConstants.DISABILITY_TEXT_PLACEHOLDER;
    addressTextPlaceHolder = RecipientFormConstants.STREET_ADDRESS_TEXT_PLACEHOLDER;
    suburbTextPlaceHolder = RecipientFormConstants.SUBURB_TEXT_PLACEHOLDER;
    cityTextPlaceHolder = RecipientFormConstants.CITY_TEXT_PLACEHOLDER;
    provinceTextPlaceHolder = RecipientFormConstants.PROVINCE_TEXT_PLACEHOLDER;
    countryTextPlaceHolder = RecipientFormConstants.COUNTRY_TEXT_PLACEHOLDER;
    codeTextPlaceHolder = RecipientFormConstants.CODE_TEXT_PLACEHOLDER;
    postalATextPlaceHolder = RecipientFormConstants.POSTAL_ADDRESS_TEXT_PLACEHOLDER;
    sacapRegistrationNumberFormControlName = RecipientFormConstants.SACAP_REGISTRATION_NUMBER_FORM_CONTROL;
    sacapRegistrationVerifiedFormControlName = RecipientFormConstants.SACAP_REGISTRATION_NUMBER_VERIFIED_FORM_CONTROL;
    sacapRegistrationNumberLabel = RecipientFormConstants.SACAP_REGISTRATION_LABEL;
    sacapVerificationLabel = RecipientFormConstants.SACAP_VERIFICATION_BUTTON_LABEL;
    id = RecipientFormConstants.ID_FORM_CONTROL;
    jobId = RecipientFormConstants.JOB_ID_FORM_CONTROL;
    name = RecipientFormConstants.NAME_FORM_CONTROL;
    surname = RecipientFormConstants.SURNAME_FORM_CONTROL;
    homePhone = RecipientFormConstants.HOMEPHONE_FORM_CONTROL;
    telephone = RecipientFormConstants.TELEPHONE_FORM_CONTROL;
    cellphone = RecipientFormConstants.CELLPHONE_FORM_CONTROL;
    email = RecipientFormConstants.EMAIL_FORM_CONTROL;
    organisation = RecipientFormConstants.ORGANISATION_FORM_CONTROL;
    clientVatNumber = RecipientFormConstants.CLIENT_VAT_NO_CONTROL;
    designation = RecipientFormConstants.DESIGNATION_FORM_CONTROL;
    professionalBody = RecipientFormConstants.PROFESSIONAL_BODY_FORM_CONTROL;
    maritalStatus = RecipientFormConstants.MARITAL_STATUS_FORM_CONTROL;
    relativesFullName = RecipientFormConstants.RELATIVE_FULL_NAME_FORM_CONTROL;
    relativesContactNumber = RecipientFormConstants.RELATIVE_CONTACT_NUMBER_FORM_CONTROL;
    relativesAddress = RecipientFormConstants.RELATIVE_ADDRESS_FORM_CONTROL;
    employmentStatus = RecipientFormConstants.EMPLOYMENT_STATUS_FORM_CONTROL;
    employersName = RecipientFormConstants.EMPLOYERS_NAME_FORM_CONTROL;
    employersContactNumber = RecipientFormConstants.EMPLOYERS_CONTACT_NUMBER_FORM_CONTROL;
    employersAddress = RecipientFormConstants.EMPLOYERS_ADDRESS_FORM_CONTROL;
    idNumber = RecipientFormConstants.ID_NUMBER_FORM_CONTROL;
    passportNumber = RecipientFormConstants.PASSPORT_NUMBER_FORM_CONTROL;
    gender = RecipientFormConstants.GENDER_FORM_CONTROL;
    disabilityControl = RecipientFormConstants.DISABILITY_FORM_CONTROL;
    professionalBodyRegNum = RecipientFormConstants.PROFESSIONAL_BODY_REGISTRATION_NUMBER_FORM_CONTROL;
    streetAddress = RecipientFormConstants.ADDRESS_FORM_CONTROL;
    streetSuburb = RecipientFormConstants.SUBURB_FORM_CONTROL;
    streetCity = RecipientFormConstants.CITY_FORM_CONTROL;
    streetProvince = RecipientFormConstants.PROVINCE_FORM_CONTROL;
    streetCountry = RecipientFormConstants.COUNTRY_FORM_CONTROL;
    streetCode = RecipientFormConstants.CODE_FORM_CONTROL;
    postalAddress = RecipientFormConstants.POSTAL_ADDRESS_FORM_CONTROL;
    postalSuburb = RecipientFormConstants.POSTAL_SUBURB_FORM_CONTROL;
    postalCity = RecipientFormConstants.POSTAL_CITY_FORM_CONTROL;
    postalProvince = RecipientFormConstants.POSTAL_PROVINCE_FORM_CONTROL;
    postalCountry = RecipientFormConstants.POSTAL_COUNTRY_FORM_CONTROL;
    postalCode = RecipientFormConstants.POSTAL_CODE_FORM_CONTROL;
    invalidRecipientErrMsg = RecipientFormConstants.INVALID_RECIPIENT_MSG;
    sameAsStreetAddressText = RecipientFormConstants.SAME_AS_STREET_PLACEHOLDER;
    validationMessage = RecipientFormConstants.validationMessage;
    selectOptionText = RecipientFormConstants.PLEASE_SELECT_AN_OPTION;
    maximunLengthForThentyWord = 20;
    maximunLengthForFiftyWord = 50;
    maximunLengthForHundredWord = 100;
    maximunLengthForTwoFiftyWord = 250;
    maximunLengthFiveHundredWord = 500;
    recipientGroupSettings = [];
    sameAsResidentialChecked = false;
    groupsOptions = [];
    showRequiredMarkForSacap = true;
    showRecipientFields = true;
    showRequiredMarkForName = false;
    showRequiredMarkForSurname = false;
    showRequiredMarkForHomeTelephone = false;
    showRequiredMarkForWorkTelephone = false;
    showRequiredMarkForCellphone = false;
    showRequiredMarkForEmail = false;
    showRequiredMarkForPassportNumber = false;
    showRequiredMarkForGender = false;
    showRequiredMarkForDisability = false;
    showRequiredMarkForOrganisation = false;
    showRequiredMarkForClientVatNo = false;
    showRequiredMarkForDesignation = false;
    showRequiredMarkForProfessionalBody = false;
    showRequiredMarkForMaritalStatus = false;
    showRequiredMarkForRelativesFullName = false;
    showRequiredMarkForRelativesContactNumber = false;
    showRequiredMarkForRelativesAddress = false;
    showRequiredMarkForEmploymentStatus = false;
    showRequiredMarkForEmployersName = false;
    showRequiredMarkForEmployersContactNumber = false;
    showRequiredMarkForEmployersAddress = false;
    showRequiredMarkForIdNumber = false;
    showRequiredMarkForBodyRegNumber = false;
    showRequiredMarkForStreetAddress = false;
    showRequiredMarkForStreetSuburb = false;
    showRequiredMarkForStreetCity = false;
    showRequiredMarkForStreetProvince = false;
    showRequiredMarkForStreetCountry = false;
    showRequiredMarkForStreetCode = false;
    showRequiredMarkForPostalAddress = false;
    showRequiredMarkForPostalSuburb = false;
    showRequiredMarkForPostalCity = false;
    showRequiredMarkForPostalProvince = false;
    showRequiredMarkForPostalCountry = false;
    showRequiredMarkForPostalCode = false;
    defaultReadOnlyFields = RecipientFormConstants.DEFAULT_REQUIRED_FIELDS;
    stepMetaRecipientGroups;
    showFilter = false;
    label;
    disableAddRecipientBtn = false;
    recipientFormLabel;
    showDefaultCommunicationMethods = true;
    errHandlerObjectName = RecipientFormConstants.ERR_HANDLER_OBJ_NAME;
    organisationData;
    invalidRequiredFields = RecipientFormConstants.INVALID_REQUIRED_FIELDS_ERR_MSG;
    groupNameStringPlaceholder = RecipientFormConstants.GROUP_NAME_PLACEHOLDER;
    requiredFieldsPlaceHolder = RecipientFormConstants.REQUIRED_FIELDS_KEY;
    subscriptions = [];
    currentRecipient;
    disabled;
    externalPlaceholder = RecipientFormConstants.EXTERNAL_PLACEHOLDER;
    moduleIDControl = RecipientFormConstants.MODULE_ID_FORM_CONTROL;
    // private readonly moduleId;
    disableControls = true;
    currentRecipientGroupType;
    lookups;
    // control visibility
    showNameControl = true;
    showSurnameControl = true;
    showHomeTelephoneControl = true;
    showWorkTelephoneControl = true;
    showCellphoneControl = true;
    showEmailControl = true;
    showIdNumberControl = true;
    showPassportNumberControl = false;
    showGenderControl = false;
    showDisabilityControl = false;
    showOrganisationControl = true;
    showDesignationControl = true;
    showProfessionalBodyControl = true;
    showProfessionalBodyRegNumControl = true;
    showMaritalStatusControl = true;
    showClientVatNumberControl = true;
    showRelativesFullNameControl = true;
    showRelativesContactNumberControl = true;
    showRelativesAddressControl = true;
    showEmploymentStatusControl = true;
    showEmployersNameControl = true;
    showEmployersContactNumberControl = true;
    showEmployersAddressControl = true;
    showStreetAddressControl = true;
    showStreetSuburbControl = true;
    showStreetCityControl = true;
    showStreetProvinceControl = true;
    showStreetCountryControl = true;
    showStreetCodeControl = true;
    showPostalAddressControl = true;
    showPostalSuburbControl = true;
    showPostalCityControl = true;
    showPostalProvinceControl = true;
    showPostalCountryControl = true;
    showPostalCodeControl = true;
    verifySACAPRegistrationSubscription;
    getLookupsObservableSubscription;
    markSACAPFieldAsReadOnly = false;
    constructor(appController, formBuilder, settingsService, recipientSelectService, userInformationService, changeDetectorRef) {
        this.appController = appController;
        this.formBuilder = formBuilder;
        this.settingsService = settingsService;
        this.recipientSelectService = recipientSelectService;
        this.userInformationService = userInformationService;
        this.changeDetectorRef = changeDetectorRef;
    }
    get value() {
        return this.recipientForm.value;
    }
    set value(value) {
        this.currentRecipient = value;
        this.recipientForm.patchValue(value);
        this.recipientForm.get(this.id).patchValue(value.id);
        if (value.hasOwnProperty(this.jobId)) {
            this.recipientForm.get(this.jobId).patchValue(value.jobId);
        }
        // if (this.currentRecipient.hasOwnProperty(this.sacapRegistrationNumberFormControlName)) {
        this.recipientForm.get(this.sacapRegistrationNumberFormControlName).patchValue(this.currentRecipient.sacapRegistrationNumber);
        // }
        // if (this.currentRecipient.hasOwnProperty(this.sacapRegistrationVerifiedFormControlName)) {
        this.recipientForm.get(this.sacapRegistrationVerifiedFormControlName).patchValue(this.currentRecipient.sacapRegistrationNumberVerified);
        // }
        if (this.currentRecipient.sacapRegistrationNumber && this.currentRecipient.sacapRegistrationNumberVerified) {
            this.markSACAPFieldAsReadOnly = true;
            this.showRequiredMarkForSacap = false;
        }
        this.recipientForm.get(this.moduleIDControl).patchValue(value.moduleId);
        this.recipientForm.get(this.name).patchValue(value.name);
        this.recipientForm.get(this.surname).patchValue(value.surname);
        this.recipientForm.get(this.homePhone).patchValue(value.homePhone);
        this.recipientForm.get(this.telephone).patchValue(value.telephone);
        this.recipientForm.get(this.cellphone).patchValue(value.cellphone);
        this.recipientForm.get(this.email).patchValue(value.email);
        this.recipientForm.get(this.passportNumber).patchValue(value.passportNumber);
        this.recipientForm.get(this.gender).patchValue(value.gender);
        this.recipientForm.get(this.disabilityControl).patchValue(value.disability);
        this.recipientForm.get(this.defaultCommunicationMethodFormControl).patchValue(value.defaultCommunicationMethod);
        this.recipientForm.get(this.organisation).patchValue(value.organisation);
        this.recipientForm.get(this.clientVatNumber).patchValue(value.clientVatNumber);
        this.recipientForm.get(this.designation).patchValue(value.designation);
        this.recipientForm.get(this.professionalBody).patchValue(value.professionalBody);
        this.recipientForm.get(this.professionalBodyRegNum).patchValue(value.professionalBodyRegNum);
        this.recipientForm.get(this.maritalStatus).patchValue(value.maritalStatus);
        this.recipientForm.get(this.relativesFullName).patchValue(value.relativesFullName);
        this.recipientForm.get(this.relativesContactNumber).patchValue(value.relativesContactNumber);
        this.recipientForm.get(this.relativesAddress).patchValue(value.relativesAddress);
        this.recipientForm.get(this.employmentStatus).patchValue(value.employmentStatus);
        this.recipientForm.get(this.employersName).patchValue(value.employersName);
        this.recipientForm.get(this.employersContactNumber).patchValue(value.employersContactNumber);
        this.recipientForm.get(this.employersAddress).patchValue(value.employersAddress);
        this.recipientForm.get(this.idNumber).patchValue(value.idNumber);
        this.recipientForm.get(this.streetAddress).patchValue(value.streetAddress);
        this.recipientForm.get(this.streetSuburb).patchValue(value.streetSuburb);
        this.recipientForm.get(this.streetCity).patchValue(value.streetCity);
        this.recipientForm.get(this.streetProvince).patchValue(value.streetProvince);
        this.recipientForm.get(this.streetCountry).patchValue(value.streetCountry);
        this.recipientForm.get(this.streetCode).patchValue(value.streetCode);
        this.recipientForm.get(this.postalAddress).patchValue(value.postalAddress);
        this.recipientForm.get(this.postalSuburb).patchValue(value.postalSuburb);
        this.recipientForm.get(this.postalCity).patchValue(value.postalCity);
        this.recipientForm.get(this.postalProvince).patchValue(value.postalProvince);
        this.recipientForm.get(this.postalCode).patchValue(value.postalCode);
        this.recipientForm.get(this.postalCountry).patchValue(value.postalCountry);
        if (!value.hasOwnProperty("overrideGroup")) {
            this.patchGroups(value.groups);
            this.recipientForm.get(this.groups).patchValue(value.groups);
        }
        else {
            value.groups = this.recipientGroupsToFilterBy.map(group => {
                return { groupName: group.groupName, groupType: group.groupType };
            });
            this.recipientForm.get(this.groups).patchValue(value.groups);
            value.groupsStringArray = this.setGroupStringArray(this.recipientGroupsToFilterBy);
        }
        this.onChange(value);
        this.onTouched();
        this.checkAddressFields();
    }
    ngOnChanges(changes) {
        if (changes.hasOwnProperty("recipientGroupsToFilterBy") && changes.recipientGroupsToFilterBy.currentValue && changes.recipientGroupsToFilterBy.currentValue.length > 0) {
            this.recipientGroupsToFilterBy = changes.recipientGroupsToFilterBy.currentValue;
            this.stepMetaRecipientGroups = this.recipientGroupsToFilterBy;
            if (this.stepMetaRecipientGroups && this.recipientGroupsToFilterBy && this.recipientForm && !this.isModalForm && !this.isInternalRecipient) {
                this.checkInitialStepMetaGroups();
                this.loadRecipientGroupSettings();
                this.checkOrganisationSettings();
                this.checkSACAPOptions();
                this.changeDetectorRef.detectChanges();
            }
        }
        if (changes.hasOwnProperty("configurableLabel") && changes.configurableLabel.currentValue && changes.configurableLabel.currentValue.length > 0) {
            this.configurableLabel = changes.configurableLabel.currentValue;
            this.label = changes.configurableLabel.currentValue;
            /*       this.configureComponentForUseAsTheBaseForm();
                  this.configureComponentForUseInSettingsModule(); */
        }
    }
    ngOnInit() {
        this.stepMetaRecipientGroups = this.recipientGroupsToFilterBy;
        this.initialiseForm();
        this.configureComponent();
        this.getRecipientGroupsLookups();
        this.loadRecipientGroupSettings();
        this.checkOrganisationSettings();
        this.checkSACAPOptions();
        this.populateDropdowns();
    }
    ngAfterViewInit() {
        this.checkAddressFields();
        this.currentRecipient = this.recipientForm.getRawValue();
        this.recipientForm.patchValue(this.currentRecipient);
        this.onChange(this.currentRecipient);
        this.onTouched();
        this.recipientForm.updateValueAndValidity();
        this.checkSACAPOptions();
        this.changeDetectorRef.detectChanges();
    }
    loadRecipientGroupSettings() {
        if (this.recipientGroupSettings.length === 0) {
            this.recipientSelectService.getRecipientGroupSettings().pipe(takeUntil(this._destroy$), take(1)).subscribe({
                next: (response) => {
                    this.recipientGroupSettings = response;
                    this.setRequiredFields();
                }, error: () => {
                    this.appController.showMessage("Configuration for recipient group settings incomplete", AlertType.Error);
                }
            });
        }
    }
    loadRecipient(recipient) {
        if (recipient) {
            // this.recipientGroupsToFilterBy.map(groupObject => {
            //   if (recipient.groups.length > 0) {
            //     // Preserve groups
            //   } else {
            //     // add groups from the metadata
            //     recipient.groups = this.recipientGroupsToFilterBy.map(group => {
            //       return {groupName: group.groupName, groupType: group.groupType};
            //     })
            //   }
            //   recipient.groupsStringArray = recipient.groups.map(groupObj => groupObj.groupName);
            // });
            recipient.groupsStringArray = recipient.groups.map(groupObj => groupObj.groupName);
            this.disableEditing = false;
            this.enableAllFields();
            this.recipientForm.patchValue(recipient);
            this.checkAddressFields();
            this.onChange(recipient);
            this.onTouched();
            this.checkAddressFields();
            this.currentRecipient = recipient;
        }
        else {
            this.appController.showMessage(this.invalidRecipientErrMsg, AlertType.Error);
        }
    }
    onSameAsResidentialChecked(event) {
        const checkBoxStatus = event.target.checked;
        if (checkBoxStatus) {
            this.sameAsResidentialChecked = true;
            this.disablePostalFields();
        }
        else {
            this.sameAsResidentialChecked = false;
            this.enablePostalFields();
        }
        this.currentRecipient = this.recipientForm.getRawValue();
        this.recipientForm.patchValue(this.currentRecipient);
        this.onChange(this.currentRecipient);
        this.onTouched();
    }
    onResidentialInputEntered(event, formControlName) {
        if (this.sameAsResidentialChecked) {
            const inputValue = event.target.value;
            const postalFormControl = this.recipientForm.get(formControlName);
            postalFormControl.patchValue(inputValue);
        }
    }
    onChange = () => {
    };
    onTouched = () => {
    };
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    writeValue(value) {
        if (value) {
            this.value = value;
        }
        if (value === null) {
            // this.resetComponent();
        }
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
        if (isDisabled) {
            this.recipientForm.disable();
            this.disableEditing = true;
        }
        else {
            this.recipientForm.enable();
            this.disableEditing = false;
        }
    }
    validate(_) {
        return this.recipientForm.valid ? null : { recipient: { valid: false } };
    }
    updateModel() {
        if (!this.isInternalRecipient && this.isModalForm) {
            const valueFromControl = this.recipientForm.get(this.groupsStringArrayControlName).value;
            const groups = valueFromControl.map((groupStringValue) => {
                return {
                    groupName: groupStringValue,
                    groupType: this.isEditRecipientModalForm ? this.currentRecipientGroupType : this.externalPlaceholder
                };
            });
            this.recipientForm.get(this.groups).patchValue(groups);
        }
    }
    disablePostalSelects(formControlName) {
        if (this.sameAsResidentialChecked) {
            this.recipientForm.get(formControlName).disable();
        }
    }
    enablePostalSelects(formControlName) {
        if (this.sameAsResidentialChecked) {
            this.recipientForm.get(formControlName).enable();
        }
    }
    checkMetadataForDisableStatus() {
        if (!this.isInternalRecipient && !this.isModalForm) {
            this.enableAllFields();
            this.sameAsResidentialChecked = false;
            this.disableEditing = false;
        }
    }
    loadRecipientFromFilter(recipient) {
        if (recipient) {
            this.recipientForm.patchValue(recipient);
        }
    }
    onVerifySacapDetails() {
        const constituentId = this.recipientForm.get(this.sacapRegistrationNumberFormControlName).value;
        this.verifySACAPRegistrationSubscription = this.recipientSelectService.verifySACAPRegistration(constituentId).subscribe({
            next: (response) => {
                this.setSACAPRecipientData(response);
                this.setSACAPRecipientVerification();
                this.changeDetectorRef.detectChanges();
                this.appController.showMessage("membership validated", AlertType.Success);
            },
            error: (error) => {
                this.clearSACAPRecipientVerification();
                switch (error.status) {
                    case 404: {
                        this.appController.showMessage(error.error, AlertType.Error);
                        break;
                    }
                    case 403: {
                        this.appController.showMessage(error.error, AlertType.Error);
                        break;
                    }
                    default: {
                        this.appController.handleServerErrorMessage("Recipient verification", error, CRUDOperation.Get);
                    }
                }
            }
        });
    }
    onRadioButtonChanged(selectedMethodOfCommunication) {
        const preferredMethodOfCommunication = selectedMethodOfCommunication.trim().toLowerCase();
        const emailFormControl = this.recipientForm.get(this.email);
        const cellphoneFormControl = this.recipientForm.get(this.cellphone);
        const recipientGroup = this.recipientGroupsToFilterBy[0];
        const isCellPhoneRequiredFromMetaData = this.isCellphoneFormFieldRequiredInTheMetadata(recipientGroup);
        const isEmailRequiredFromMetadata = this.isEmailFormFieldRequiredInTheMetadata(recipientGroup);
        if (preferredMethodOfCommunication.toLowerCase().trim() === "email") {
            this.setEmailFormFieldAsRequired(emailFormControl);
            if (isCellPhoneRequiredFromMetaData) {
                this.setCellphoneFormFieldAsRequired(cellphoneFormControl);
            }
            else {
                this.clearCellphoneFormFieldRequiredValidation(cellphoneFormControl);
            }
        }
        if (preferredMethodOfCommunication.toLowerCase().trim() === "sms") {
            this.setCellphoneFormFieldAsRequired(cellphoneFormControl);
            if (isEmailRequiredFromMetadata) {
                this.setEmailFormFieldAsRequired(emailFormControl);
            }
            else {
                this.clearEmailFormFieldRequiredValidation(emailFormControl);
            }
        }
        this.changeDetectorRef.detectChanges();
    }
    patchGroups(recipientGroups) {
        const groupsStringArrayControl = this.recipientForm.get(this.groupsStringArrayControlName);
        if (this.isInternalRecipient && recipientGroups && recipientGroups.length > 0) {
            this.patchGroupsForRecipientComponentInSettings(groupsStringArrayControl, recipientGroups);
        }
        else {
            if (recipientGroups && recipientGroups.length > 0) {
                groupsStringArrayControl.patchValue(this.setRecipientGroupsFormControl(recipientGroups));
                this.currentRecipientGroupType = recipientGroups[0].groupType;
                const groupsArray = groupsStringArrayControl.value.map((recipientGroupString) => {
                    return {
                        groupName: recipientGroupString, groupType: this.currentRecipientGroupType
                    };
                });
                this.recipientForm.get(this.groups).patchValue(groupsArray);
            }
        }
    }
    patchGroupsForRecipientComponentInSettings(groupsStringArrayControl, incomingRecipientGroupObject) {
        // responsible for patching groups in the recipient component In settings
        groupsStringArrayControl.patchValue(this.setRecipientGroupsFormControl(incomingRecipientGroupObject));
    }
    getOrganisationData() {
        const orgId = this.userInformationService.getOrganisationId(+this.appController.selectedModuleID);
        this.organisationData = this.userInformationService.getOrganisationInformation(orgId);
    }
    initialiseForm() {
        this.recipientForm = this.formBuilder.group({
            id: new FormControl(0),
            sacapRegistrationNumber: new FormControl({ value: null, disabled: this.disableControls }),
            sacapRegistrationNumberVerified: new FormControl({ value: null, disabled: this.disableControls }),
            jobId: new FormControl(null),
            moduleId: new FormControl(+this.appController.selectedModuleID),
            name: new FormControl({ value: null, disabled: this.disableControls }),
            surname: new FormControl({ value: null, disabled: this.disableControls }),
            homePhone: new FormControl({ value: null, disabled: this.disableControls }, phoneNumberValidator),
            telephone: new FormControl({ value: null, disabled: this.disableControls }, phoneNumberValidator),
            cellphone: new FormControl({ value: null, disabled: this.disableControls }, phoneNumberValidator),
            defaultCommunicationMethod: new FormControl("Email"),
            email: new FormControl({ value: null, disabled: this.disableControls }, Validators.email),
            organisation: new FormControl({ value: null, disabled: this.disableControls }),
            clientVatNumber: new FormControl({ value: null, disabled: this.disableControls }),
            designation: new FormControl({ value: null, disabled: this.disableControls }),
            professionalBody: new FormControl({ value: null, disabled: this.disableControls }),
            professionalBodyRegNum: new FormControl({ value: null, disabled: this.disableControls }),
            maritalStatus: new FormControl({ value: null, disabled: this.disableControls }),
            relativesFullName: new FormControl({ value: null, disabled: this.disableControls }),
            relativesContactNumber: new FormControl({ value: null, disabled: this.disableControls }),
            relativesAddress: new FormControl({ value: null, disabled: this.disableControls }),
            employmentStatus: new FormControl({ value: null, disabled: this.disableControls }),
            employersName: new FormControl({ value: null, disabled: this.disableControls }),
            employersContactNumber: new FormControl({ value: null, disabled: this.disableControls }),
            employersAddress: new FormControl({ value: null, disabled: this.disableControls }),
            idNumber: new FormControl({ value: null, disabled: this.disableControls }),
            streetAddress: new FormControl({ value: null, disabled: this.disableControls }),
            streetSuburb: new FormControl({ value: null, disabled: this.disableControls }),
            streetCity: new FormControl({ value: null, disabled: this.disableControls }),
            streetProvince: new FormControl({ value: null, disabled: this.disableControls }),
            streetCountry: new FormControl({ value: SharedConstants.DEFAULT_COUNTRY, disabled: this.disableControls }),
            streetCode: new FormControl({ value: null, disabled: this.disableControls }, Validators.minLength(4)),
            postalAddress: new FormControl({ value: null, disabled: this.disableControls }),
            postalSuburb: new FormControl({ value: null, disabled: this.disableControls }),
            postalCity: new FormControl({ value: null, disabled: this.disableControls }),
            postalProvince: new FormControl({ value: null, disabled: this.disableControls }),
            postalCountry: new FormControl({ value: SharedConstants.DEFAULT_COUNTRY, disabled: this.disableControls }),
            postalCode: new FormControl({ value: null, disabled: this.disableControls }, [Validators.minLength(4)]),
            passportNumber: new FormControl({ value: null, disabled: this.disableControls }),
            gender: new FormControl({ value: null, disabled: this.disableControls }),
            disability: new FormControl({ value: null, disabled: this.disableControls }),
            groupsStringArray: new FormControl(null, this.isInternalRecipient ? Validators.required : null),
            groups: new FormControl(null)
        });
        this.subscriptions.push(this.recipientForm.valueChanges.subscribe(value => {
            this.onChange(value);
            this.onTouched();
        }));
        this.subscriptions.push(this.recipientSelectService.markFormControlAsTouched.subscribe((markControlsAsTouched) => {
            this.markRecipientControlsAsTouched();
            this.onTouched();
        }));
        this.subscriptions.push(this.recipientSelectService.resetForm.subscribe((resetComponent) => {
            this.resetComponent();
            this.onTouched();
        }));
    }
    populateFormWithOrganisationData(organisationData) {
        if (organisationData !== null) {
            (this.recipientForm.get(this.organisation)).patchValue(organisationData.name);
            (this.recipientForm.get(this.streetAddress)).patchValue(organisationData.streetAddress);
            (this.recipientForm.get(this.streetSuburb)).patchValue(organisationData.streetSuburb);
            (this.recipientForm.get(this.streetCity)).patchValue(organisationData.streetCity);
            (this.recipientForm.get(this.streetProvince)).patchValue(organisationData.streetProvince);
            (this.recipientForm.get(this.streetCode)).patchValue(organisationData.streetCode);
            (this.recipientForm.get(this.postalAddress)).patchValue(organisationData.postalAddress);
            (this.recipientForm.get(this.postalSuburb)).patchValue(organisationData.postalSuburb);
            (this.recipientForm.get(this.postalCity)).patchValue(organisationData.postalCity);
            (this.recipientForm.get(this.postalProvince)).patchValue(organisationData.postalProvince);
            (this.recipientForm.get(this.postalCode)).patchValue(organisationData.postalCode);
        }
        else {
            this.appController.showMessage(this.invalidRecipientErrMsg, AlertType.Error);
        }
    }
    enablePostalFields() {
        this.restorePostalFieldValidators();
        this.recipientForm.updateValueAndValidity();
    }
    disablePostalFields() {
        this.clearPostalControlsValidators();
        this.copyStreetAddressData();
        this.recipientForm.updateValueAndValidity();
    }
    copyStreetAddressData() {
        this.recipientForm.get(this.postalAddress).patchValue(this.recipientForm.get(this.streetAddress).value);
        this.recipientForm.get(this.postalSuburb).patchValue(this.recipientForm.get(this.streetSuburb).value);
        this.recipientForm.get(this.postalCity).patchValue(this.recipientForm.get(this.streetCity).value);
        this.recipientForm.get(this.postalProvince).patchValue(this.recipientForm.get(this.streetProvince).value);
        this.recipientForm.get(this.postalCountry).patchValue(this.recipientForm.get(this.streetCountry).value);
        this.recipientForm.get(this.postalCode).patchValue(this.recipientForm.get(this.streetCode).value);
    }
    getRecipientGroupsLookups() {
        if (this.isAddRecipientModalForm) {
            this.groupsOptions = this.recipientGroupsToFilterBy.map((groupObj) => {
                return {
                    code: groupObj.groupName, value: groupObj.groupName
                };
            });
        }
        else if (this.isEditRecipientModalForm) {
            this.groupsOptions = this.recipientGroupsToFilterBy.map((groupObj) => {
                return {
                    code: groupObj.groupName, value: groupObj.groupName
                };
            });
        }
        else {
            this.recipientSelectService.getRecipientGroupSettings().pipe(takeUntil(this._destroy$), take(1)).subscribe({
                next: (settings) => {
                    this.onGetRecipientGroupsLookupsCompleted(settings);
                }, error: (error) => {
                    this.appController.handleServerErrorMessage(this.errHandlerObjectName, error, CRUDOperation.Get);
                }
            });
        }
    }
    onGetRecipientGroupsLookupsCompleted(settings) {
        this.populateRecipientGroupsDropDown(settings);
        if (this.isInternalRecipient && this.isAddRecipientModalForm) {
            this.getOrganisationData();
            this.populateFormWithOrganisationData(this.organisationData);
        }
    }
    setRecipientGroupsFormControl(groups) {
        const groupsArray = [];
        if (groups) {
            groups.forEach((group) => {
                if (group.hasOwnProperty(this.groupNameStringPlaceholder)) {
                    groupsArray.push(group.groupName);
                }
                else {
                    groupsArray.push(group);
                }
            });
        }
        return groupsArray;
    }
    setRequiredFields() {
        if (this.recipientGroupsToFilterBy && this.recipientGroupsToFilterBy.length > 0) {
            const group = this.recipientGroupsToFilterBy[0];
            if (this.recipientGroupSettings.length > 0) {
                const settings = this.recipientGroupSettings.find(x => x.name.trim() === group.groupName.trim() && x.type === group.groupType);
                if (settings) {
                    group.requiredFields = JSON.parse(settings.configuration);
                    const metaDataRequiredFields = group.requiredFields;
                    this.addRequiredFieldsValidatorOnControls(metaDataRequiredFields);
                }
                else {
                    this.appController.showMessage(`Configuration for recipient group settings incomplete GroupName: ${group.groupName}`, AlertType.Error);
                    group.requiredFields = null;
                }
            }
            else {
                this.appController.showMessage("Configuration for recipient group settings incomplete", AlertType.Error);
            }
        }
        else {
            this.addRequiredFieldsValidatorOnControls(this.defaultReadOnlyFields);
        }
    }
    addRequiredFieldsValidatorOnControls(requiredFields) {
        Object.keys(this.recipientForm.controls).forEach(formControl => {
            requiredFields.forEach((item) => {
                item.name = this.formatObjectKey(item.name);
                if (formControl.toLocaleLowerCase() === item.name.toLowerCase()) {
                    this.showOrHideControl(formControl, item.visible);
                    this.setFieldControlValidators(formControl, item.required);
                    this.showOrHideRequiredFieldMark(formControl, item.required);
                    this.checkOrganisationSettings(); // late check for default communications validations;
                }
            });
        });
        this.recipientForm.updateValueAndValidity();
        this.changeDetectorRef.detectChanges();
    }
    formatObjectKey(name) {
        const wordArr = name.split(" ");
        wordArr.forEach((word, index) => {
            wordArr[index] = word.charAt(0).toUpperCase() + word.slice(1);
        });
        name = wordArr.join("");
        let keyToChange = name;
        if (keyToChange.toLocaleLowerCase() === "professionalbodyregistrationnumber") {
            keyToChange = "professionalBodyRegNum";
        }
        if (keyToChange === "Homephone") {
            keyToChange = "HomePhone";
        }
        const formattedString = keyToChange.charAt(0).toLowerCase() + keyToChange.slice(1);
        return formattedString;
    }
    showOrHideRequiredFieldMark(controlName, required) {
        switch (controlName) {
            case this.name:
                this.showRequiredMarkForName = required;
                break;
            case this.surname:
                this.showRequiredMarkForSurname = required;
                break;
            case this.homePhone:
                this.showRequiredMarkForHomeTelephone = required;
                break;
            case this.telephone:
                this.showRequiredMarkForWorkTelephone = required;
                break;
            case this.cellphone:
                this.showRequiredMarkForCellphone = required;
                break;
            case this.email:
                this.showRequiredMarkForEmail = required;
                break;
            case this.passportNumber:
                this.showRequiredMarkForPassportNumber = required;
                break;
            case this.gender:
                this.showRequiredMarkForGender = required;
                break;
            case this.disabilityControl:
                this.showRequiredMarkForDisability = required;
                break;
            case this.organisation:
                this.showRequiredMarkForOrganisation = required;
                break;
            case this.designation:
                this.showRequiredMarkForDesignation = required;
                break;
            case this.clientVatNumber:
                this.showRequiredMarkForClientVatNo = required;
                break;
            case this.professionalBody:
                this.showRequiredMarkForProfessionalBody = required;
                break;
            case this.professionalBodyRegNum:
                this.showRequiredMarkForBodyRegNumber = required;
                break;
            case this.maritalStatus:
                this.showRequiredMarkForMaritalStatus = required;
                break;
            case this.relativesFullName:
                this.showRequiredMarkForRelativesFullName = required;
                break;
            case this.relativesContactNumber:
                this.showRequiredMarkForRelativesContactNumber = required;
                break;
            case this.relativesAddress:
                this.showRequiredMarkForRelativesAddress = required;
                break;
            case this.employmentStatus:
                this.showRequiredMarkForEmploymentStatus = required;
                break;
            case this.employersName:
                this.showRequiredMarkForEmployersName = required;
                break;
            case this.employersContactNumber:
                this.showRequiredMarkForEmployersContactNumber = required;
                break;
            case this.employersAddress:
                this.showRequiredMarkForEmployersAddress = required;
                break;
            case this.idNumber:
                this.showRequiredMarkForIdNumber = required;
                break;
            case this.streetAddress:
                this.showRequiredMarkForStreetAddress = required;
                break;
            case this.streetCity:
                this.showRequiredMarkForStreetCity = required;
                break;
            case this.streetSuburb:
                this.showRequiredMarkForStreetSuburb = required;
                break;
            case this.streetProvince:
                this.showRequiredMarkForStreetProvince = required;
                break;
            case this.streetCountry:
                this.showRequiredMarkForStreetCountry = required;
                break;
            case this.streetCode:
                this.showRequiredMarkForStreetCode = required;
                break;
            case this.postalAddress:
                this.showRequiredMarkForPostalAddress = required;
                break;
            case this.postalCity:
                this.showRequiredMarkForPostalCity = required;
                break;
            case this.postalSuburb:
                this.showRequiredMarkForPostalSuburb = required;
                break;
            case this.postalProvince:
                this.showRequiredMarkForPostalProvince = required;
                break;
            case this.postalCountry:
                this.showRequiredMarkForPostalCountry = required;
                break;
            case this.postalCode:
                this.showRequiredMarkForPostalCode = required;
                break;
            default:
                this.appController.showMessage(this.invalidRequiredFields, AlertType.Warning);
                break;
        }
    }
    showOrHideControl(controlName, visible) {
        switch (controlName) {
            case this.name:
                this.showNameControl = visible;
                break;
            case this.surname:
                this.showSurnameControl = visible;
                break;
            case this.homePhone:
                this.showHomeTelephoneControl = visible;
                break;
            case this.telephone:
                this.showWorkTelephoneControl = visible;
                break;
            case this.cellphone:
                this.showCellphoneControl = visible;
                break;
            case this.email:
                this.showEmailControl = visible;
                break;
            case this.idNumber:
                this.showIdNumberControl = visible;
                break;
            case this.passportNumber:
                this.showPassportNumberControl = visible;
                break;
            case this.gender:
                this.showGenderControl = visible;
                break;
            case this.disabilityControl:
                this.showDisabilityControl = visible;
                break;
            case this.organisation:
                this.showOrganisationControl = visible;
                break;
            case this.designation:
                this.showDesignationControl = visible;
                break;
            case this.professionalBody:
                this.showProfessionalBodyControl = visible;
                break;
            case this.professionalBodyRegNum:
                this.showProfessionalBodyRegNumControl = visible;
                break;
            case this.maritalStatus:
                this.showMaritalStatusControl = visible;
                break;
            case this.relativesFullName:
                this.showRelativesFullNameControl = visible;
                break;
            case this.clientVatNumber:
                this.showClientVatNumberControl = visible;
                break;
            case this.relativesContactNumber:
                this.showRelativesContactNumberControl = visible;
                break;
            case this.relativesAddress:
                this.showRelativesAddressControl = visible;
                break;
            case this.employmentStatus:
                this.showEmploymentStatusControl = visible;
                break;
            case this.employersName:
                this.showEmployersNameControl = visible;
                break;
            case this.employersContactNumber:
                this.showEmployersContactNumberControl = visible;
                break;
            case this.employersAddress:
                this.showEmployersAddressControl = visible;
                break;
            case this.streetAddress:
                this.showStreetAddressControl = visible;
                break;
            case this.streetCity:
                this.showStreetCityControl = visible;
                break;
            case this.streetSuburb:
                this.showStreetSuburbControl = visible;
                break;
            case this.streetProvince:
                this.showStreetProvinceControl = visible;
                break;
            case this.streetCountry:
                this.showStreetCountryControl = visible;
                break;
            case this.streetCode:
                this.showStreetCodeControl = visible;
                break;
            case this.postalAddress:
                this.showPostalAddressControl = visible;
                break;
            case this.postalCity:
                this.showPostalCityControl = visible;
                break;
            case this.postalSuburb:
                this.showPostalSuburbControl = visible;
                break;
            case this.postalProvince:
                this.showPostalProvinceControl = visible;
                break;
            case this.postalCountry:
                this.showPostalCountryControl = visible;
                break;
            case this.postalCode:
                this.showPostalCodeControl = visible;
                break;
            default:
                this.appController.showMessage(this.invalidRequiredFields, AlertType.Warning);
                break;
        }
    }
    setFieldControlValidators(controlName, required) {
        if (required === true) {
            if (controlName === this.homePhone || controlName === this.telephone || controlName === this.cellphone) {
                this.recipientForm.get(controlName).setValidators([Validators.required, phoneNumberValidator]);
                return;
            }
            if (controlName === this.streetCode || controlName === this.postalCode) {
                this.recipientForm.get(controlName).setValidators([Validators.required, Validators.minLength(4)]);
                this.recipientForm.get(controlName).updateValueAndValidity();
                return;
            }
            if (controlName === this.email) {
                this.recipientForm.get(controlName).setValidators([Validators.required, Validators.email]);
                this.recipientForm.get(controlName).updateValueAndValidity();
                return;
            }
            this.recipientForm.get(controlName).setValidators(Validators.required);
            this.recipientForm.get(controlName).updateValueAndValidity();
            this.recipientForm.updateValueAndValidity();
        }
        else {
            this.recipientForm.get(controlName).clearValidators();
        }
    }
    configureComponent() {
        if (this.isInternalRecipient) {
            this.configureComponentForUseInSettingsModule();
        }
        else {
            this.configureComponentForUseInSteps();
        }
    }
    checkAddressFields() {
        const streetAddressValue = this.recipientForm.get(this.streetAddress).value;
        const postalAddressValue = this.recipientForm.get(this.postalAddress).value;
        const streetSuburbValue = this.recipientForm.get(this.streetSuburb).value;
        const postalSuburbValue = this.recipientForm.get(this.postalSuburb).value;
        const streetCityValue = this.recipientForm.get(this.streetCity).value;
        const postalCityValue = this.recipientForm.get(this.postalCity).value;
        const streetProvinceValue = this.recipientForm.get(this.streetProvince).value;
        const postalProvinceValue = this.recipientForm.get(this.postalProvince).value;
        const streetCountryValue = this.recipientForm.get(this.streetCountry).value;
        const postalCountryValue = this.recipientForm.get(this.postalCountry).value;
        const streetCodeValue = this.recipientForm.get(this.streetCode).value;
        const postalCodeValue = this.recipientForm.get(this.postalCode).value;
        if (((streetAddressValue !== null) && (streetAddressValue === postalAddressValue)) && ((streetSuburbValue !== null) && (streetSuburbValue === postalSuburbValue)) && ((streetCityValue !== null) && (streetCityValue === postalCityValue)) && ((streetProvinceValue !== null) && (streetProvinceValue === postalProvinceValue)) && ((streetCountryValue !== null) && (streetCountryValue === postalCountryValue)) && ((streetCodeValue !== null) && (streetCodeValue === postalCodeValue))) {
            this.sameAsResidentialChecked = true;
        }
        else {
            this.sameAsResidentialChecked = false;
        }
    }
    markRecipientControlsAsTouched() {
        Object.keys(this.recipientForm.controls).forEach((controlName) => {
            if (controlName !== this.groupsStringArrayControlName) {
                this.recipientForm.get(controlName).markAsTouched();
            }
        });
        this.changeDetectorRef.detectChanges();
    }
    resetComponent() {
        this.recipientForm.reset();
        if (this.recipientSelectFilter)
            this.recipientSelectFilter.resetComponent();
        if (this.jobID)
            this.recipientForm.get(this.jobId).patchValue(+this.jobId);
        if (+this.appController.selectedModuleID)
            this.recipientForm.get(this.jobId).patchValue(+this.appController.selectedModuleID);
        this.sameAsResidentialChecked = false;
        this.currentRecipient = undefined;
        this.markSACAPFieldAsReadOnly = false;
        this.changeDetectorRef.detectChanges();
    }
    enableAllFields() {
        Object.keys(this.recipientForm.controls).forEach((controlName) => {
            if (this.recipientForm.get(controlName).disabled) {
                this.recipientForm.get(controlName).enable();
            }
        });
        this.changeDetectorRef.detectChanges();
    }
    disableAllFields() {
        Object.keys(this.recipientForm.controls).forEach((controlName) => {
            if (this.recipientForm.get(controlName).enabled) {
                this.recipientForm.get(controlName).disable();
            }
        });
        this.changeDetectorRef.detectChanges();
    }
    configureComponentForUseInSteps() {
        if (this.isModalForm) {
            this.configureComponentForUseOnAModal();
        }
        else {
            this.configureComponentForUseAsTheBaseForm();
        }
    }
    configureComponentForUseOnAModal() {
        this.enableAllFields();
        if (this.recipientGroupsToFilterBy.length === 1) {
            this.recipientForm.get(this.groupsStringArrayControlName).patchValue([this.recipientGroupsToFilterBy[0].groupName]);
            this.recipientForm.get(this.groups).patchValue(this.recipientGroupsToFilterBy);
            this.showRecipientGroupsDropdown = false;
        }
    }
    configureComponentForUseAsTheBaseForm() {
        if (this.disableEditing) {
            this.sameAsResidentialChecked = true;
            this.disableAllFields();
        }
        else {
            this.sameAsResidentialChecked = false;
            this.enableAllFields();
        }
        if (this.disableAdd) {
            this.disableAddRecipientBtn = true;
        }
        else {
            this.disableAddRecipientBtn = false;
        }
        if (this.disableFilter) {
            this.showFilter = false;
        }
        else {
            this.showFilter = true;
        }
        if (this.showFields) {
            this.showRecipientFields = true;
        }
        else {
            this.showRecipientFields = false;
        }
        this.label = this.configurableLabel;
        this.recipientFormLabel = this.configurableLabel ? `${this.configurableLabel} details` : `Personal details`;
        this.checkInitialStepMetaGroups();
    }
    configureComponentForUseInSettingsModule() {
        this.showFilter = !this.disableFilter;
        this.enableAllFields();
        this.recipientFormLabel = this.configurableLabel ? `${this.configurableLabel} details` : `Personal details`;
    }
    populateRecipientGroupsDropDown(settings) {
        if (this.isInternalRecipient) {
            const groupType = "Internal";
            const internalGroupsSpecified = settings.find(x => x.type === groupType);
            if (internalGroupsSpecified) {
                settings.forEach(setting => {
                    if (setting.type === groupType) {
                        this.groupsOptions.push({
                            code: setting.name,
                            value: setting.name
                        });
                    }
                });
            }
            else {
                settings.forEach(setting => {
                    if (setting.type === "External") {
                        this.groupsOptions.push({
                            code: setting.name,
                            value: setting.name
                        });
                    }
                });
            }
        }
        this.groupsOptions.sort((a, b) => (a.value?.localeCompare(b.value)));
        this.changeDetectorRef.detectChanges();
    }
    checkInitialStepMetaGroups() {
        if (this.recipientGroupsToFilterBy !== undefined && this.recipientGroupsToFilterBy !== null && this.recipientGroupsToFilterBy.length !== 0) {
            if (this.stepMetaRecipientGroups.length === 1) {
                this.recipientForm.get(this.groupsStringArrayControlName).patchValue([this.stepMetaRecipientGroups[0].groupName]);
                this.recipientForm.get(this.groups).patchValue(this.stepMetaRecipientGroups);
                this.showRecipientGroupsDropdown = false;
                this.changeDetectorRef.detectChanges();
            }
        }
    }
    restorePostalFieldValidators() {
        this.recipientForm.get(this.postalAddress).setValidators(Validators.required);
        this.recipientForm.get(this.postalSuburb).setValidators(Validators.required);
        this.recipientForm.get(this.postalCity).setValidators(Validators.required);
        this.recipientForm.get(this.postalProvince).setValidators(Validators.required);
        this.recipientForm.get(this.postalCountry).setValidators(Validators.required);
        this.recipientForm.get(this.postalCode).setValidators([Validators.minLength(4), Validators.required]);
    }
    clearPostalControlsValidators() {
        this.recipientForm.get(this.postalAddress).clearValidators();
        this.recipientForm.get(this.postalSuburb).clearValidators();
        this.recipientForm.get(this.postalCity).clearValidators();
        this.recipientForm.get(this.postalProvince).clearValidators();
        this.recipientForm.get(this.postalCountry).clearValidators();
        this.recipientForm.get(this.postalCode).clearValidators();
    }
    setGroupStringArray(groups) {
        const groupsStringArray = [];
        if (groups.length > 0) {
            groups.forEach(group => {
                groupsStringArray.push(group.groupName);
            });
            this.recipientForm.get(this.groupsStringArrayControlName).patchValue(groupsStringArray);
        }
        return groupsStringArray;
    }
    markFormControlsAsTouched() {
        this.recipientForm.markAllAsTouched();
        this.recipientForm.updateValueAndValidity();
    }
    checkSACAPOptions() {
        if (this.showSACAPOptions) {
            const sacapControl = this.recipientForm.get(this.sacapRegistrationNumberFormControlName);
            if (sacapControl) {
                this.recipientForm.removeControl(this.sacapRegistrationNumberFormControlName);
                this.recipientForm.updateValueAndValidity();
            }
            this.recipientForm.addControl(this.sacapRegistrationNumberFormControlName, new FormControl(null, Validators.required));
            this.recipientForm.addControl(this.sacapRegistrationVerifiedFormControlName, new FormControl(null, Validators.required));
            this.recipientForm.updateValueAndValidity();
        }
    }
    setSACAPRecipientData(memberData) {
        this.recipientForm.get(this.sacapRegistrationNumberFormControlName).clearValidators();
        this.recipientForm.get(this.sacapRegistrationNumberFormControlName).updateValueAndValidity();
        this.recipientForm.get(this.sacapRegistrationNumberFormControlName).setValue(memberData.professionalNumber);
        this.showRequiredMarkForSacap = false;
        this.recipientForm.get(this.name).setValue(memberData.firstname);
        this.recipientForm.get(this.name).clearValidators();
        this.recipientForm.get(this.surname).setValue(memberData.lastname);
        this.recipientForm.get(this.surname).clearValidators();
        this.recipientForm.get(this.professionalBody).setValue("SACAP");
        this.recipientForm.get(this.professionalBody).clearValidators();
        this.recipientForm.get(this.professionalBodyRegNum).setValue(memberData.professionalNumber);
        this.recipientForm.get(this.professionalBodyRegNum).clearValidators();
        this.recipientForm.get(this.email).setValue(memberData.email);
        this.recipientForm.get(this.email).clearValidators();
        this.recipientForm.get(this.cellphone).setValue(memberData.telephone);
        this.recipientForm.get(this.cellphone).clearValidators();
        this.recipientForm.get(this.cellphone).updateValueAndValidity();
        this.recipientForm.updateValueAndValidity();
        this.markSACAPFieldAsReadOnly = true;
    }
    setEmailFormFieldAsRequired(emailFormControl) {
        emailFormControl.setValidators([Validators.required, Validators.email]);
        this.showRequiredMarkForEmail = true;
        emailFormControl.updateValueAndValidity();
    }
    setCellphoneFormFieldAsRequired(cellphoneFormControl) {
        cellphoneFormControl.setValidators([Validators.required, phoneNumberValidator]);
        this.showRequiredMarkForCellphone = true;
        cellphoneFormControl.updateValueAndValidity();
    }
    isCellphoneFormFieldRequiredInTheMetadata(recipientGroup) {
        let isCellphoneRequired = false;
        if (this.isInternalRecipient) {
            isCellphoneRequired = true;
            this.showRequiredMarkForCellphone = true;
            this.showRequiredMarkForEmail = false;
            return isCellphoneRequired;
        }
        if (this.recipientGroupsToFilterBy.length > 0 && recipientGroup.hasOwnProperty(this.requiredFieldsPlaceHolder) && this.getPropertyThatMatchesDataCase(recipientGroup.requiredFields, "Cellphone", "cellphone")) {
            isCellphoneRequired = true;
        }
        return isCellphoneRequired;
    }
    isEmailFormFieldRequiredInTheMetadata(recipientGroup) {
        let isEsmailRequired = false;
        if (this.isInternalRecipient) {
            isEsmailRequired = true;
            this.showRequiredMarkForEmail = true;
            this.showRequiredMarkForCellphone = false;
            return isEsmailRequired;
        }
        if (this.recipientGroupsToFilterBy.length > 0 && recipientGroup.hasOwnProperty(this.requiredFieldsPlaceHolder) && this.getPropertyThatMatchesDataCase(recipientGroup.requiredFields, "Email", "email")) {
            isEsmailRequired = true;
        }
        return isEsmailRequired;
    }
    clearCellphoneFormFieldRequiredValidation(cellphoneFormControl) {
        cellphoneFormControl.clearValidators();
        this.showRequiredMarkForCellphone = false;
        cellphoneFormControl.markAsUntouched();
        cellphoneFormControl.addValidators(phoneNumberValidator);
    }
    clearEmailFormFieldRequiredValidation(emailFormControl) {
        emailFormControl.clearValidators();
        this.showRequiredMarkForEmail = false;
        emailFormControl.markAsUntouched();
        emailFormControl.addValidators(Validators.email);
    }
    getOrganisationSettings() {
        if (this.appController.selectedOrganisationId !== undefined || this.appController.selectedOrganisationId !== null) {
            const moduleId = Number(this.appController.selectedModuleID);
            const module = this.userInformationService.getModuleInformation(moduleId);
            this.appController.selectedOrganisationID(module.organisationId);
        }
        const organisationId = Number(this.appController.selectedOrganisationId);
        const getOrganisationInformation = this.userInformationService.getOrganisationInformation(organisationId);
        if (getOrganisationInformation.settings) {
            return getOrganisationInformation.settings;
        }
        else {
            return null;
        }
    }
    setDefaultCommunicationSettings(organisationSettings) {
        this.showDefaultCommunicationMethods = false;
        const isSMSEnabledFromOrganisationSettings = organisationSettings.enableSms;
        const hasSMSProvider = (!(organisationSettings.smsProvider === null || organisationSettings.smsProvider === "" || organisationSettings.smsProvider === "null"));
        if (isSMSEnabledFromOrganisationSettings && hasSMSProvider) {
            this.showDefaultCommunicationMethods = true;
            const defaultCommunicationMethod = this.recipientForm.get(this.defaultCommunicationMethodFormControl).value;
            if (defaultCommunicationMethod) {
                this.onRadioButtonChanged(defaultCommunicationMethod);
            }
        }
        else {
            this.showDefaultCommunicationMethods = false;
        }
        this.changeDetectorRef.detectChanges();
    }
    getPropertyThatMatchesDataCase(propertyObject, name1, name2) {
        let returnVal = null;
        if (propertyObject) {
            for (const [key, value] of Object.entries(propertyObject)) {
                if (key === name1) {
                    returnVal = propertyObject.hasOwnProperty(name1) && value !== null ? value : null;
                    break;
                }
                else if (key === name1.toLowerCase()) {
                    returnVal = propertyObject.hasOwnProperty(name1.toLowerCase()) && value !== null ? value : null;
                    break;
                }
                else if (name2 && key === name2) {
                    returnVal = propertyObject.hasOwnProperty(name2) && value !== null ? value : null;
                    break;
                }
            }
        }
        return returnVal;
    }
    checkOrganisationSettings() {
        const organisationSettings = this.getOrganisationSettings();
        if (organisationSettings) {
            this.setDefaultCommunicationSettings(organisationSettings);
        }
        else {
            this.disableCommunicationMethods();
        }
    }
    disableCommunicationMethods() {
        this.showDefaultCommunicationMethods = false;
    }
    setSACAPRecipientVerification() {
        const control = this.recipientForm.get(this.sacapRegistrationVerifiedFormControlName);
        if (control) {
            control.setValue(true);
        }
    }
    clearSACAPRecipientVerification() {
        this.recipientForm.get(this.sacapRegistrationVerifiedFormControlName).reset();
        this.recipientForm.get(this.sacapRegistrationNumberFormControlName).reset();
        this.recipientForm.get(this.sacapRegistrationNumberFormControlName).addValidators(Validators.required);
        this.showRequiredMarkForSacap = true;
        this.recipientForm.get(this.name).reset();
        this.recipientForm.get(this.surname).reset();
        this.recipientForm.get(this.professionalBody).reset();
        this.recipientForm.get(this.professionalBodyRegNum).reset();
        this.recipientForm.get(this.email).reset();
        this.recipientForm.get(this.cellphone).reset();
        this.markSACAPFieldAsReadOnly = false;
        this.setRequiredFields();
    }
    populateDropdowns() {
        const gender$ = this.getLookups('recipient gender');
        const disabled$ = this.getLookups('recipient disabled');
        this.genderOptions = [];
        this.disabilityOptions = [];
        forkJoin([gender$, disabled$]).subscribe({
            next: ([genderOptions, disabledOptions]) => {
                if (genderOptions.length > 0) {
                    genderOptions.forEach((genderOption) => {
                        this.genderOptions.push(JSON.parse(genderOption.content));
                    });
                }
                if (disabledOptions.length > 0) {
                    disabledOptions.forEach((disabledOption) => {
                        this.disabilityOptions.push(JSON.parse(disabledOption.content));
                    });
                }
                this.genderOptions.sort((a, b) => (a.value?.localeCompare(b.value)));
                this.disabilityOptions.sort((a, b) => (a.value?.localeCompare(b.value)));
                this.changeDetectorRef.detectChanges();
            },
            error: (error) => {
                this.appController.handleServerErrorMessage(RecipientFormConstants.MISSING_LOOKUPS, error, CRUDOperation.Get);
            }
        });
    }
    getLookups(name) {
        const params = {
            $filter: `moduleId eq ${Number(this.appController.selectedModuleID)} and deleted eq false and tolower(name) eq '${name.toLowerCase()}'`,
        };
        return this.settingsService.getLookupsObservable(params).pipe(map(lookups => {
            return lookups.value;
        }));
    }
    static ctorParameters = () => [
        { type: AppControllerService },
        { type: FormBuilder },
        { type: SettingsService },
        { type: RecipientSelectService },
        { type: UserInformationService },
        { type: ChangeDetectorRef }
    ];
    static propDecorators = {
        recipientSelectFilter: [{ type: ViewChild, args: [RecipientSelectFilterComponent,] }],
        showFields: [{ type: Input }],
        disableFilter: [{ type: Input }],
        isInternalRecipient: [{ type: Input }],
        configurableLabel: [{ type: Input }],
        disableAdd: [{ type: Input }],
        recipientGroupsToFilterBy: [{ type: Input }],
        disableEditing: [{ type: Input }],
        showRecipientGroupsDropdown: [{ type: Input }],
        isModalForm: [{ type: Input }],
        isAddRecipientModalForm: [{ type: Input }],
        isEditRecipientModalForm: [{ type: Input }],
        jobID: [{ type: Input }],
        showSACAPOptions: [{ type: Input }]
    };
};
RecipientSelectComponent = __decorate([
    Component({
        selector: "app-recipient-select",
        template: __NG_CLI_RESOURCE__0,
        providers: [{
                provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => RecipientSelectComponent), multi: true
            }, {
                provide: NG_VALIDATORS, useExisting: forwardRef(() => RecipientSelectComponent), multi: true
            }],
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], RecipientSelectComponent);
export { RecipientSelectComponent };
